/**
 * Created by kierangrosvenor on 05/05/2017.
 */

import Vue from 'vue'
export default new Vue;



// WEBPACK FOOTER //
// ./src/helpers/EventBus/index.js